module.exports = __webpack_public_path__ + "static/media/Q4-1.45228eac.jpg";